module.exports = __webpack_public_path__ + "static/media/carousel_three_medium_720x480.6478c319.jpg";